
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexnYmHAlwAuMz8509JlEkPdEcTOcSsFYjOGBM_4540Q2Pn0Meta } from "/app/packages/frontend-bo/src/pages/index.vue?macro=true";
import { default as indexJnVOsEPLFSRvok2iuodNUyzUm3iF1bHbmjUkGZfc3m4Meta } from "/app/packages/frontend-bo/src/pages/eig/index.vue?macro=true";
import { default as cgusw0qW8izGwVfMVP9YOM9P1edTiBqDoTwVdqn2xaMJMwMeta } from "/app/packages/frontend-bo/src/pages/footer/cgu.vue?macro=true";
import { default as _91eigId_93XcHJEOzfDlyj9xw5tqGfpOzeGNPanTHt5itxUly4owkMeta } from "/app/packages/frontend-bo/src/pages/eig/[eigId].vue?macro=true";
import { default as tousAZrjARfmj_rW8y3fO3Fsmy33j7BJoP2urCDE4UbmVoQMeta } from "/app/packages/frontend-bo/src/pages/hebergements/tous.vue?macro=true";
import { default as lies_45a_45des_45sejoursoOnU9gsWTHiUXjN4wmvtj27RHf1PshXE6ApJCiY86o0Meta } from "/app/packages/frontend-bo/src/pages/hebergements/lies-a-des-sejours.vue?macro=true";
import { default as hebergementsGwlFmnTVU7z0Cj6rc67OOqYi6dathTC6b1w87Ou_45ccsMeta } from "/app/packages/frontend-bo/src/pages/hebergements.vue?macro=true";
import { default as listepQ2bDX052yYu9n21az3najt1l6EhYXuycrleEDAdXicMeta } from "/app/packages/frontend-bo/src/pages/comptes/liste.vue?macro=true";
import { default as index0sRDwdIz6zHanSUPAc2MvmZ4q7FYCSmDD5o9UZ8oLmAMeta } from "/app/packages/frontend-bo/src/pages/sejours/index.vue?macro=true";
import { default as listea33oQfcdxpiQzxeVGgNy8hnSfZQYc0ZSbVCxSOhZWwsMeta } from "/app/packages/frontend-bo/src/pages/agrements/liste.vue?macro=true";
import { default as indexDYLMieQOAMWpkA_s7_iysFPbNazOq4VO1DmsH7u91usMeta } from "/app/packages/frontend-bo/src/pages/connexion/index.vue?macro=true";
import { default as indexIb6KQsiZHqeUtQ8yUBAra5NcbNi0W8UaY1nieO3CxWsMeta } from "/app/packages/frontend-bo/src/pages/messagerie/index.vue?macro=true";
import { default as liste17IsTMBEZBuMduWrrTNoI0NUxtCVxP0O2dORmJIlA1QMeta } from "/app/packages/frontend-bo/src/pages/organismes/liste.vue?macro=true";
import { default as listetSJwY9V_1vz5OJdqDsQv30OPZzWo4TOh8ma4mHlKLOEMeta } from "/app/packages/frontend-bo/src/pages/territoires/liste.vue?macro=true";
import { default as _91_91userId_93_93PPXvWtFXhFZV2QMpd8TDit2JzboXmdhgdQGGUOvHgr8Meta } from "/app/packages/frontend-bo/src/pages/comptes/[[userId]].vue?macro=true";
import { default as mon_45compteCbW58vj0EAKp2fOMfGwXNFp50Bi382gwpEsgGoLUq1MMeta } from "/app/packages/frontend-bo/src/pages/comptes/mon-compte.vue?macro=true";
import { default as indexRLRA1n2Q3Y5Yzb0oyd_fSoPmr_bEX269eM5YCPit94QMeta } from "/app/packages/frontend-bo/src/pages/informations/index.vue?macro=true";
import { default as validationVPWJVtntCuvbSGoRnru1nQ_451IvwhKLLke4SsuMqb8HsMeta } from "/app/packages/frontend-bo/src/pages/connexion/validation.vue?macro=true";
import { default as accessibiliteXZ3_45HAJ0vtMiyI8ybdoVYy8al2_39Z4liBWhU_45cY8_450Meta } from "/app/packages/frontend-bo/src/pages/footer/accessibilite.vue?macro=true";
import { default as _91agrementId_93svJaP9CPkToA05IUZUKWTTOLIq0uFyoSGn3fJcbh4I4Meta } from "/app/packages/frontend-bo/src/pages/agrements/[agrementId].vue?macro=true";
import { default as gestion_45cookiesQdBWnIHdoOGR1KyZho0WaGDPxxpcIKpcO0GFCdYK_egMeta } from "/app/packages/frontend-bo/src/pages/footer/gestion-cookies.vue?macro=true";
import { default as listeJ2kNYwWayIiQBVi_gRvegSYr60Kzd1E6uCXxgFGNJrQMeta } from "/app/packages/frontend-bo/src/pages/utilisateurs-ova/liste.vue?macro=true";
import { default as liste_45organismewHcLMA33f0TXjvJBMsT6HMmQ3ej6D7RGz1tsrLgbw_45cMeta } from "/app/packages/frontend-bo/src/pages/comptes/liste-organisme.vue?macro=true";
import { default as mentions_45legalesg7cg3nSf0awdpx2_45kcfmMi23eNIibyA4uh_JbTWULpYMeta } from "/app/packages/frontend-bo/src/pages/footer/mentions-legales.vue?macro=true";
import { default as eigXvohN9rj0jnTfMOb3kEzM5Zf95HMhwDUBMp_45fPSeWkgMeta } from "/app/packages/frontend-bo/src/pages/sejours/[declarationId]/eig.vue?macro=true";
import { default as documentsCZk_hQ6XyTrt_45PmgWZnUxBdQcGMvEuFUXNBueIuQKYwMeta } from "/app/packages/frontend-bo/src/pages/sejours/[declarationId]/documents.vue?macro=true";
import { default as formulairertdSA5lKn_VwRuCUyuF9v8HsrPm8lnI5wl2EIpbKRXcMeta } from "/app/packages/frontend-bo/src/pages/sejours/[declarationId]/formulaire.vue?macro=true";
import { default as historique1OribQvYxeNnCgQ1kMU_RhB67eoh8fjrOxR0noPFVj4Meta } from "/app/packages/frontend-bo/src/pages/sejours/[declarationId]/historique.vue?macro=true";
import { default as messageriefZV0JnW13iIaSR3XkTZFJgKle_zqMdG5nNIb3OVVmTkMeta } from "/app/packages/frontend-bo/src/pages/sejours/[declarationId]/messagerie.vue?macro=true";
import { default as _91declarationId_93L_45LmF4ipK36FCI3ZknIuAPVDymrvbvYIOXuwJ43L2xUMeta } from "/app/packages/frontend-bo/src/pages/sejours/[declarationId].vue?macro=true";
import { default as indexnVgsGmNYqAi39HTvhX8bWBJ_45JvvZSYMVUBlHWrY2HnMMeta } from "/app/packages/frontend-bo/src/pages/hebergement/[type]/index.vue?macro=true";
import { default as verification_45otpuAG_45FBlsv7dxMF2Fog64vHlK_hc_45whFq4nKsZAA4vyMMeta } from "/app/packages/frontend-bo/src/pages/connexion/verification-otp.vue?macro=true";
import { default as _91_91organismeId_93_93p4gnpCMjiwxf4dkJYICymGyptNxcrTp5TmGQY9r58JoMeta } from "/app/packages/frontend-bo/src/pages/organismes/[[organismeId]].vue?macro=true";
import { default as donnees_45personnellesLOsSjsQsmDnqsinWrYB4Gxzjt0WM6r7LEJ0mo6mVRnQMeta } from "/app/packages/frontend-bo/src/pages/footer/donnees-personnelles.vue?macro=true";
import { default as reset_45mot_45de_45passeXy_hlS15_qN1gjJasADDWW1BEmfTWFNtGv6xCLONKV0Meta } from "/app/packages/frontend-bo/src/pages/connexion/reset-mot-de-passe.vue?macro=true";
import { default as _91_91territoireId_93_93w1zzAmjlvym0VjjHskMEUyIx69X7U2oj_45o0mbuNK9RAMeta } from "/app/packages/frontend-bo/src/pages/territoires/[[territoireId]].vue?macro=true";
import { default as mot_45de_45passe_45oubliePfaJ5MA9WiTpr2YFyH9Iai2LKJc18HEfxkOQOuugkyYMeta } from "/app/packages/frontend-bo/src/pages/connexion/mot-de-passe-oublie.vue?macro=true";
import { default as _91hebergementId_93Pl85JHm3QrDmxDADfbVfEaeI_LKZKPmXh9_J_45iFMbZEMeta } from "/app/packages/frontend-bo/src/pages/hebergement/[type]/[hebergementId].vue?macro=true";
import { default as _91hebergementId_93EB1IFw_DiBTYWPYN_SGrLU1_imECh0iEN8RsCBhTH8gMeta } from "/app/packages/frontend-bo/src/pages/hebergement/[type]/[demandeSejourId]/[hebergementId].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: { ...(indexnYmHAlwAuMz8509JlEkPdEcTOcSsFYjOGBM_4540Q2Pn0Meta || {}), ...{"middleware":["is-connected"]} },
    component: () => import("/app/packages/frontend-bo/src/pages/index.vue")
  },
  {
    name: "eig",
    path: "/eig",
    meta: { ...(indexJnVOsEPLFSRvok2iuodNUyzUm3iF1bHbmjUkGZfc3m4Meta || {}), ...{"middleware":["is-connected","check-role"]} },
    component: () => import("/app/packages/frontend-bo/src/pages/eig/index.vue")
  },
  {
    name: "footer-cgu",
    path: "/footer/cgu",
    component: () => import("/app/packages/frontend-bo/src/pages/footer/cgu.vue")
  },
  {
    name: "eig-eigId",
    path: "/eig/:eigId()",
    meta: { ...(_91eigId_93XcHJEOzfDlyj9xw5tqGfpOzeGNPanTHt5itxUly4owkMeta || {}), ...{"middleware":["is-connected","check-role","check-eig-id-param"]} },
    component: () => import("/app/packages/frontend-bo/src/pages/eig/[eigId].vue")
  },
  {
    name: "hebergements",
    path: "/hebergements",
    meta: { ...(hebergementsGwlFmnTVU7z0Cj6rc67OOqYi6dathTC6b1w87Ou_45ccsMeta || {}), ...{"middleware":["is-connected","check-role"]} },
    component: () => import("/app/packages/frontend-bo/src/pages/hebergements.vue"),
    children: [
  {
    name: "hebergements-tous",
    path: "tous",
    component: () => import("/app/packages/frontend-bo/src/pages/hebergements/tous.vue")
  },
  {
    name: "hebergements-lies-a-des-sejours",
    path: "lies-a-des-sejours",
    component: () => import("/app/packages/frontend-bo/src/pages/hebergements/lies-a-des-sejours.vue")
  }
]
  },
  {
    name: "comptes-liste",
    path: "/comptes/liste",
    meta: { ...(listepQ2bDX052yYu9n21az3najt1l6EhYXuycrleEDAdXicMeta || {}), ...{"middleware":["is-connected","check-role"]} },
    component: () => import("/app/packages/frontend-bo/src/pages/comptes/liste.vue")
  },
  {
    name: "sejours",
    path: "/sejours",
    meta: { ...(index0sRDwdIz6zHanSUPAc2MvmZ4q7FYCSmDD5o9UZ8oLmAMeta || {}), ...{"middleware":["is-connected","check-role"]} },
    component: () => import("/app/packages/frontend-bo/src/pages/sejours/index.vue")
  },
  {
    name: "agrements-liste",
    path: "/agrements/liste",
    meta: {"middleware":["is-connected","check-feature-flags"]},
    component: () => import("/app/packages/frontend-bo/src/pages/agrements/liste.vue")
  },
  {
    name: "connexion",
    path: "/connexion",
    component: () => import("/app/packages/frontend-bo/src/pages/connexion/index.vue")
  },
  {
    name: "messagerie",
    path: "/messagerie",
    meta: { ...(indexIb6KQsiZHqeUtQ8yUBAra5NcbNi0W8UaY1nieO3CxWsMeta || {}), ...{"middleware":["is-connected","check-role"]} },
    component: () => import("/app/packages/frontend-bo/src/pages/messagerie/index.vue")
  },
  {
    name: "organismes-liste",
    path: "/organismes/liste",
    meta: {"middleware":["is-connected"]},
    component: () => import("/app/packages/frontend-bo/src/pages/organismes/liste.vue")
  },
  {
    name: "territoires-liste",
    path: "/territoires/liste",
    meta: {"middleware":["is-connected"]},
    component: () => import("/app/packages/frontend-bo/src/pages/territoires/liste.vue")
  },
  {
    name: "comptes-userId",
    path: "/comptes/:userId?",
    meta: { ...(_91_91userId_93_93PPXvWtFXhFZV2QMpd8TDit2JzboXmdhgdQGGUOvHgr8Meta || {}), ...{"middleware":["is-connected","check-role"]} },
    component: () => import("/app/packages/frontend-bo/src/pages/comptes/[[userId]].vue")
  },
  {
    name: "comptes-mon-compte",
    path: "/comptes/mon-compte",
    meta: {"middleware":["is-connected"]},
    component: () => import("/app/packages/frontend-bo/src/pages/comptes/mon-compte.vue")
  },
  {
    name: "informations",
    path: "/informations",
    meta: { ...(indexRLRA1n2Q3Y5Yzb0oyd_fSoPmr_bEX269eM5YCPit94QMeta || {}), ...{"middleware":["is-connected","check-role"]} },
    component: () => import("/app/packages/frontend-bo/src/pages/informations/index.vue")
  },
  {
    name: "connexion-validation",
    path: "/connexion/validation",
    component: () => import("/app/packages/frontend-bo/src/pages/connexion/validation.vue")
  },
  {
    name: "footer-accessibilite",
    path: "/footer/accessibilite",
    component: () => import("/app/packages/frontend-bo/src/pages/footer/accessibilite.vue")
  },
  {
    name: "agrements-agrementId",
    path: "/agrements/:agrementId()",
    component: () => import("/app/packages/frontend-bo/src/pages/agrements/[agrementId].vue")
  },
  {
    name: "footer-gestion-cookies",
    path: "/footer/gestion-cookies",
    component: () => import("/app/packages/frontend-bo/src/pages/footer/gestion-cookies.vue")
  },
  {
    name: "utilisateurs-ova-liste",
    path: "/utilisateurs-ova/liste",
    component: () => import("/app/packages/frontend-bo/src/pages/utilisateurs-ova/liste.vue")
  },
  {
    name: "comptes-liste-organisme",
    path: "/comptes/liste-organisme",
    meta: {"middleware":["is-connected"]},
    component: () => import("/app/packages/frontend-bo/src/pages/comptes/liste-organisme.vue")
  },
  {
    name: "footer-mentions-legales",
    path: "/footer/mentions-legales",
    component: () => import("/app/packages/frontend-bo/src/pages/footer/mentions-legales.vue")
  },
  {
    name: "sejours-declarationId",
    path: "/sejours/:declarationId()",
    meta: { ...(_91declarationId_93L_45LmF4ipK36FCI3ZknIuAPVDymrvbvYIOXuwJ43L2xUMeta || {}), ...{"middleware":["is-connected"]} },
    component: () => import("/app/packages/frontend-bo/src/pages/sejours/[declarationId].vue"),
    children: [
  {
    name: "sejours-declarationId-eig",
    path: "eig",
    component: () => import("/app/packages/frontend-bo/src/pages/sejours/[declarationId]/eig.vue")
  },
  {
    name: "sejours-declarationId-documents",
    path: "documents",
    component: () => import("/app/packages/frontend-bo/src/pages/sejours/[declarationId]/documents.vue")
  },
  {
    name: "sejours-declarationId-formulaire",
    path: "formulaire",
    component: () => import("/app/packages/frontend-bo/src/pages/sejours/[declarationId]/formulaire.vue")
  },
  {
    name: "sejours-declarationId-historique",
    path: "historique",
    component: () => import("/app/packages/frontend-bo/src/pages/sejours/[declarationId]/historique.vue")
  },
  {
    name: "sejours-declarationId-messagerie",
    path: "messagerie",
    component: () => import("/app/packages/frontend-bo/src/pages/sejours/[declarationId]/messagerie.vue")
  }
]
  },
  {
    name: "hebergement-type",
    path: "/hebergement/:type()",
    meta: { ...(indexnVgsGmNYqAi39HTvhX8bWBJ_45JvvZSYMVUBlHWrY2HnMMeta || {}), ...{"middleware":["is-connected","check-role"]} },
    component: () => import("/app/packages/frontend-bo/src/pages/hebergement/[type]/index.vue")
  },
  {
    name: "connexion-verification-otp",
    path: "/connexion/verification-otp",
    component: () => import("/app/packages/frontend-bo/src/pages/connexion/verification-otp.vue")
  },
  {
    name: "organismes-organismeId",
    path: "/organismes/:organismeId?",
    meta: {"middleware":["is-connected"]},
    component: () => import("/app/packages/frontend-bo/src/pages/organismes/[[organismeId]].vue")
  },
  {
    name: "footer-donnees-personnelles",
    path: "/footer/donnees-personnelles",
    component: () => import("/app/packages/frontend-bo/src/pages/footer/donnees-personnelles.vue")
  },
  {
    name: "connexion-reset-mot-de-passe",
    path: "/connexion/reset-mot-de-passe",
    component: () => import("/app/packages/frontend-bo/src/pages/connexion/reset-mot-de-passe.vue")
  },
  {
    name: "territoires-territoireId",
    path: "/territoires/:territoireId?",
    meta: {"middleware":["is-connected"]},
    component: () => import("/app/packages/frontend-bo/src/pages/territoires/[[territoireId]].vue")
  },
  {
    name: "connexion-mot-de-passe-oublie",
    path: "/connexion/mot-de-passe-oublie",
    component: () => import("/app/packages/frontend-bo/src/pages/connexion/mot-de-passe-oublie.vue")
  },
  {
    name: "hebergement-type-hebergementId",
    path: "/hebergement/:type()/:hebergementId()",
    meta: {"middleware":["is-connected"]},
    component: () => import("/app/packages/frontend-bo/src/pages/hebergement/[type]/[hebergementId].vue")
  },
  {
    name: "hebergement-type-demandeSejourId-hebergementId",
    path: "/hebergement/:type()/:demandeSejourId()/:hebergementId()",
    meta: {"middleware":["is-connected"]},
    component: () => import("/app/packages/frontend-bo/src/pages/hebergement/[type]/[demandeSejourId]/[hebergementId].vue")
  }
]